<h1 mat-dialog-title cy-data="dialog-title" class="title"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle>{{title}}</h1>
<div mat-dialog-content class="content">
  <ng-content></ng-content>
</div>
<div class="footer" mat-dialog-actions>

  <ac-button  *ngIf="!hideCancelButton" (click)="cancel()" [ngClass]="'clear'"
              class="ac-dialog-button arm-cancel-button">{{cancelButtonName}}</ac-button>
  <ac-button  *ngIf="!hideOkButton" (click)="submit()"
              [ngDisabled]="disabled" class="ac-dialog-button">{{confirmButtonName}}</ac-button>

<!--

  <button mat-raised-button class="arm-dialog-cancel-button" cy-data="cancel" *ngIf="!hideCancelButton"
          (click)="cancel()">{{cancelButtonName}}</button>
  <button class="arm-dialog-ok-button" [disabled]="disabled"
          type="submit"
          cy-data="submit"
          mat-raised-button color="primary"
          (click)="submit()">
    {{confirmButtonName}}
  </button>
-->

</div>
